/**
 * 存储适配
 */
import storageEnum from '@/enums/storageEnum'
class StorageAdapter {
  constructor() {
    // do nothing
  }
  install(Vue) {
    Vue.$storage = Vue.prototype.$storage = this
  }
  init(type) {
    if (!type || storageEnum.window(type)) {
      this.storage = window.sessionStorage
      this.storage.__IS_WINDOW_STORAGE = true
    }
  }
  /**
   * 获取存储key前缀
   */
  getKeyPrefix() {
    return ''
  }
  /**
   * 返回所有key列表
   * @returns
   */
  length() {
    return this.storage.length
  }

  /**
   * 根据索引返回key值
   * @param {*} index
   * @returns
   */
  key(index) {
    return this.storage.key(index)
  }
  /**
   * 设置数据
   * @param {*} key
   * @param {*} value
   * @param {*} hasKeyPrefix
   * key是否有前缀
   */
  setItem(key, value) {
    let newKey = key
    var reg = /[.]local$/
    if (value === null || value === undefined) {
      if (this.storage.__IS_WINDOW_STORAGE && reg.test(key)) {
        window.localStorage.setItem(newKey.replace(reg, ''), '')
        return
      }
      this.storage.setItem(newKey, '')
    } else {
      if (this.storage.__IS_WINDOW_STORAGE && reg.test(key)) {
        window.localStorage.setItem(
          newKey.replace(reg, ''),
          JSON.stringify(value)
        )
        return
      }
      this.storage.setItem(newKey, JSON.stringify(value))
    }
  }
  /**
   * 获取key获取数据
   * @param {*} key
   */
  getItem(key) {
    if (key === undefined || key === null) return null

    let newKey = key

    let item
    if (this.storage.__IS_WINDOW_STORAGE) {
      item = window.localStorage.getItem(newKey)
    }
    item = item || this.storage.getItem(newKey)
    if (item !== null && item != undefined && item.length > 0)
      return JSON.parse(item)
    return null
  }
  removeItem(key) {
    let newKey = key
    window.localStorage.removeItem(newKey)
    this.storage.removeItem(newKey)
  }
  /**
   * 全部清空
   */
  clear() {
    this.storage.clear()
    window.localStorage.clear()
  }
}

const storageAdapter = new StorageAdapter()
export default storageAdapter



// WEBPACK FOOTER //
// ./src/utils/storage/storage-adapter.js